// Centralized sample golf cart data used by GolfCarts and GolfCartDetail pages
export const sampleGolfCarts = [
  {
    id: 1,
    condition: 'used',
    brand: 'Club Car',
    model: 'Onward 4 Passenger',
    price: 12999,
    image: '/assets/assets/images/golfCart/Epic-E40FX-Golf-Cart_silver.png',
    features: ['Lithium Battery', 'LED Lights', 'USB Charging', 'Premium Seats'],
    topSpeed: '25 mph',
    range: '50 miles',
    year: 2024,
    passengers: 4,
    vin: 'CC24ONW4P12345',
    description: 'Club Car Onward with lithium battery, premium seats, and full LED lighting package.'
  },
  {
    id: 2,
    condition: 'used',
    brand: 'E-Z-GO',
    model: 'Express S4',
    price: 10999,
    image: '/assets/assets/images/golfCart/Denago-Rover-XL-Blue-1-1.webp',
    features: ['Extended Roof', 'Bluetooth Speakers', 'Turn Signals', 'Full Lighting Package'],
    topSpeed: '20 mph',
    range: '40 miles',
    year: 2024,
    passengers: 4,
    vin: 'EZ24EXPS467890',
    description: 'E-Z-GO Express S4 with extended roof, upgraded audio, and full lighting package. Great for golf courses and gated communities.'
  },
  {
    id: 3,
    condition: 'used',
    brand: 'Yamaha',
    model: 'Drive2 PTV',
    price: 7999,
    image: '/assets/assets/images/golfCart/E40FX-Logo-Headlight-Blue-Front.png',
    features: ['AC Motor', 'Independent Suspension', 'Folding Windshield', 'Cooler Storage'],
    topSpeed: '19 mph',
    range: '35 miles',
    year: 2022,
    passengers: 2,
    vin: 'YM22DRV2P98765',
    description: 'Lightly used Yamaha Drive2 with AC motor, excellent suspension, and comfort package.'
  },
  {
    id: 4,
    condition: 'used',
    brand: 'Star EV',
    model: 'Sirius 6',
    price: 15999,
    image: '/assets/assets/images/golfCart/Evolution D5 B-Green.png',
    features: ['6 Passenger', 'Aluminum Frame', 'Digital Display', 'Premium Suspension', 'Custom Wheels'],
    vin: 'STAR24SIR66789',
    topSpeed: '25 mph',
    range: '45 miles',
    year: 2024,
    passengers: 6,
    description: 'Star EV Sirius 6 with aluminum frame, digital display, and premium suspension.'
  },
  {
    id: 5,
    condition: 'used',
    brand: 'E-Z-GO',
    model: 'RXV Elite',
    price: 8999,
    image: '/assets/assets/images/golfCart/Evolution D3 B-Silver-Grey.png',
    features: ['48V System', 'Regenerative Braking', 'LED Package', 'Weather Enclosure', 'Storage Compartment'],
    vin: 'EZ22RXVE11111',
    topSpeed: '22 mph',
    range: '38 miles',
    year: 2021,
    passengers: 2,
    description: 'E-Z-GO RXV Elite with chrome appearance package and rear seat kit.'
  },
  {
    id: 6,
    condition: 'used',
    brand: 'Yamaha',
    model: 'Adventurer Sport',
    price: 11999,
    image: '/assets/assets/images/golfCart/IMG_3210_1200x1200.webp',
    features: ['Sport Package', 'LED Headlights', 'Digital Display', 'Regenerative Braking'],
    topSpeed: '23 mph',
    range: '48 miles',
    year: 2024,
    passengers: 2,
    description: 'Yamaha Adventurer Sport with sport package and advanced braking technology.'
  }
];

export default sampleGolfCarts;
